import React from 'react';
import styled from 'styled-components';
import { ButtonPrimary } from '@yuhu-inc/yuhui';

const StyledSend = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
`;

const StyledPostButton = styled(ButtonPrimary)`
  height: 29px !important;
  line-height: 29px !important;
  padding: 0px 18px !important;
`;

const PostButton = ({ disabled }) => (
  <StyledSend>
    <StyledPostButton type="submit" contentKey="post" disabled={disabled} />
  </StyledSend>
);

export default PostButton;
